export default "__VITE_ASSET__70ea1956__"